var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.774414,
    y: 1.16666,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6341 15.3095H7.68621C7.03499 15.3095 6.50708 14.7898 6.50708 14.1488L6.50713 7.18451C6.50713 6.54347 7.03505 6.0238 7.68626 6.0238H12.9925C13.6437 6.0238 14.1717 6.54347 14.1717 7.18452V9.50596M8.57076 8.34524H12.1082M8.57076 10.0863H12.1082M8.57076 11.8274H10.3395M14.6269 11.1051L15.5755 12.0537M12.2554 14.4252L13.4058 14.1934C13.4669 14.1811 13.523 14.151 13.567 14.1069L16.1424 11.5302C16.2659 11.4067 16.2658 11.2064 16.1422 11.083L15.5967 10.5381C15.4731 10.4147 15.273 10.4148 15.1496 10.5382L12.5739 13.1152C12.5299 13.1592 12.4999 13.2152 12.4876 13.2761L12.2554 14.4252Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionReport);
export default __webpack_public_path__ + "static/media/question-report.9192494f9855149d40440f54c7869173.svg";
export { ForwardRef as ReactComponent };